import { render, staticRenderFns } from "./CommonChart.vue?vue&type=template&id=c3b68c5a&scoped=true"
import script from "./CommonChart.vue?vue&type=script&lang=js"
export * from "./CommonChart.vue?vue&type=script&lang=js"
import style0 from "./CommonChart.vue?vue&type=style&index=0&id=c3b68c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b68c5a",
  null
  
)

export default component.exports